import { patchMsalSessionStorage } from "./msalStorage";

// src/authConfig.js
patchMsalSessionStorage();

const origin = window.location.origin;

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: `https://bluegeckosso.ciamlogin.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
    redirectUri: origin
  },
  cache: {
    cacheLocation: "sessionStorage", // or sessionStorage
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid"], // Add additional scopes here
};

